<template>
    <div class="year-datepicker">


        <datepicker v-model="data" name="name" :language="es" :full-month-name="true" :monday-first="true"  :placeholder="label"
            :format="'yyyy'" :id="name" :minimum-view="'year'" :openDate="openDateValue" :fill="!!data"
            :disabled-dates="disabledDatesConfig" @input="emit" @opened="hideDisabledYears" 
            @changedYear="hideDisabledYears" @changedDecade="hideDisabledYears">
        </datepicker>
    </div>
</template>

<script>


    import { es } from 'vuejs-datepicker/dist/locale'
    import Datepicker from 'vuejs-datepicker';

    import moment from 'moment';
    moment.locale('es')

    export default {
        name: 'year-datepicker',
        props: ['name', 'label','value', 'maxpage'],
        mounted() {
            if(this.value != null && this.value != "" && this.value != 'Fecha inválida'){
                this.data = new Date(this.value,0,1);
            }
            this.hideDisabledYears();
            if (this.maxpage) {
                this.hideInterval = setInterval(() => {
                    this.hideDisabledYears();
                }, 100);
            }
        },
        beforeDestroy() {
            if (this.hideInterval) {
                clearInterval(this.hideInterval);
            }
        },
        data: () => ({
            data: '',
            es: es,
            hideInterval: null
        }),
        components: {
            Datepicker
        },
        computed: {
            disabledDatesConfig() {
                if (this.maxpage) {
                    const maxDate = new Date(this.maxpage);
                    const maxYear = maxDate.getFullYear();
                    const disabledFromDate = new Date(maxYear, 11, 31); 
                    return {
                        from: disabledFromDate
                    };
                }
                return {};
            },
            openDateValue() {
                if (this.maxpage) {
                    const maxDate = new Date(this.maxpage);
                    return maxDate;
                }
                if (this.data) {
                    return this.data;
                }
                return new Date();
            }
        },
        methods: {
            emit() {
                const selectedYear = moment(this.data).format('YYYY');
                if (this.maxpage) {
                    const maxYear = new Date(this.maxpage).getFullYear();
                    const yearNum = parseInt(selectedYear);
                    if (yearNum > maxYear) {
                        this.data = new Date(maxYear, 0, 1);
                        this.$emit('input', maxYear.toString());
                        return;
                    }
                }
                this.$emit('input', selectedYear);
                this.$nextTick(() => {
                    this.hideDisabledYears();
                });
            },
            hideDisabledYears() {
                if (this.maxpage && this.$el) {
                    this.$nextTick(() => {
                        const maxDate = new Date(this.maxpage);
                        const maxYear = maxDate.getFullYear();
                        const selectors = [
                            '.cell',
                            'td.cell',
                            '.vdp-datepicker__cell',
                            '[class*="cell"]',
                            'span.cell'
                        ];
                        
                        selectors.forEach(selector => {
                            const cells = this.$el.querySelectorAll(selector);
                            cells.forEach(cell => {
                                const yearText = cell.textContent.trim();
                                const year = parseInt(yearText);
                                if (!isNaN(year) && year > maxYear && year >= 1900 && year <= 2100) {
                                    cell.style.display = 'none';
                                    cell.style.visibility = 'hidden';
                                    cell.classList.add('disabled');
                                } else if (!isNaN(year) && year <= maxYear && year >= 1900) {
                                    cell.style.display = '';
                                    cell.style.visibility = '';
                                }
                            });
                        });
                    });
                }
            }
        },
        watch : {
            'value'(){
                this.data = new Date(this.value,0,1);
            },
            'maxpage'() {
                if (this.maxpage && !this.hideInterval) {
                    this.hideInterval = setInterval(() => {
                        this.hideDisabledYears();
                    }, 100);
                } else if (!this.maxpage && this.hideInterval) {
                    clearInterval(this.hideInterval);
                    this.hideInterval = null;
                }
                this.$nextTick(() => {
                    this.hideDisabledYears();
                });
            }
        }

    }
</script>